import { apiClient } from "../index";
import { deepFixMojibake } from "../../utils/fixMojibake";

const CATALOG_TREE_PATH = "/api/v1/catalog/tree";
const CATALOG_SCENARIO_PATH = "/api/v1/catalog/scenario";
const CATALOG_DASHBOARD_LINKS_PATH = "/api/v1/catalog/dashboard-links";
const FLOW_RUN_PATH = "/api/v1/flow-run";

export async function getCatalogTree() {
  const data = await apiClient.get(CATALOG_TREE_PATH);
  return deepFixMojibake(data);
}

export async function getDashboardLinks() {
  const data = await apiClient.get(CATALOG_DASHBOARD_LINKS_PATH);
  return deepFixMojibake(data);
}

/*** Flatten dashboard-links into the rows the box list renders. */
export function normalizeDashboardLinks(raw) {
  const scenarios = raw?.scenarios ?? [];

  return scenarios.map((s, i) => ({
    id: s.scenario_id ?? `box-${i}`,
    name: s.name || s.title || "Untitled box",
    category: s.category_title ?? "",
    difficulty: s.difficulty ?? null,
    labType: s.lab_type ?? null,
    hasTopology: !!s.has_topology,
    canLaunch: !!s.can_launch,
    href: (s.links ?? []).find((l) => l.rel === "launch")?.href ?? null,
  }));
}

export async function getScenarioDetails(scenarioId) {
  const data = await apiClient.get(`${CATALOG_SCENARIO_PATH}/${scenarioId}`);
  return deepFixMojibake(data);
}

export async function createScenarioRun(payload) {
  return apiClient.post(`${FLOW_RUN_PATH}/create-scenario-run`, payload);
}

// Dedicated call for the "Build Your Own" scenario modal.
export async function createBuildYourOwnRun(payload) {
  return apiClient.post(`${FLOW_RUN_PATH}/create-scenario-docker-run`, payload);
}